import {MainHelper} from "../../shared/models/main-helper";
import {CodeNameChartTabs} from "./code-name-chart-tabs";
import {CodeName} from "../../stocks/models/code-name";
import {ChartDataRow} from "./chart-data-row";
import {CodeNameTranslate} from "../../shared/models/code-name-translate";
import {TranslateService} from "@ngx-translate/core";
import {iterateListLike} from "@angular/core/src/change_detection/change_detection_util";
import {ChartLineModel} from "./amchart/chart-line-model";
import * as moment from "moment";
import { Moment } from 'moment';
import {TabItem} from "./tab-item";
import {BufferGraphService} from "../services/buffer-graph.service";
import {CommonDataService} from "../../services/common-data.service";
import {CommonService} from "../../services/common.service";
import {ColumnSettingsBase} from "../../slick-grid/models/column-settings-base";

export class ChartHelper extends MainHelper{
    constructor(){
        super();
    }

    //# generate list of tabs
    public readonly getDefaultTabsList = async (GUID: string, translateService: TranslateService, graphService: BufferGraphService, commonData: CommonDataService ): Promise<CodeNameChartTabs> =>{
        let list: CodeNameChartTabs = null;
        try{

            let data = await graphService.getTabList().toPromise();
            if (data == null || !data.success){
                //this.showLoadingImg = false;
                translateService.get('GetTabListError')
                    .subscribe(error => commonData.showInfo([error]));
                return;
            }

            list = new CodeNameChartTabs(GUID, data.tabSettings.map( (item: TabItem, i) => new TabItem(i + 1, false, item.code, '',
                item.key, item.type, item.hotKey, item.name, item.procedure, item.group, item.groupId)));
            await this.translateTabsNames(list.tabs, translateService);
        } catch (e){
            this.showError(e, () => console.error(e));
        }

        return list;
        /*return new CodeNameChartTabs(GUID, [
            new TabItem(1, false, 'IOH', '', 'ItemOrderHistory', 'OrderHistory', 'KeyO'),
            new TabItem(2, false, 'IA', '', 'Actions', 'Actions', 'KeyA'),
            new TabItem(3, false, 'BCH', '', 'BufferChangeHistory', 'BufferChangeHistory', 'KeyH'),
            new TabItem(4, false, 'BCR', '', 'BufferChangeReasons', 'BufferChangeReasons', 'KeyR'),
            new TabItem(5, false, 'SSS', '', 'OrdersSchedules', 'OrdersSchedules', 'KeyS'),
            new TabItem(6, false, 'AST', '', 'AssortmentStructure', 'AssortmentStructure', 'KeyG'),
            new TabItem(7, false, 'CD', '', 'ChartData', 'ChartData', 'KeyE'),
            new TabItem(8, false, 'TST', '', 'TestSimpleTab', 'SimpleTab', '')
        ])*/
    }


    //# translate list of tabs name
    public readonly translateTabsNames = async (data: TabItem[], translateSrv: TranslateService): Promise<void> =>{
        let translates = await translateSrv.get(data.map(item => item.key)).toPromise();
        data.forEach(item => item.name = translates[item.key]);
    }

    //# calculate real buffer for chart-data tab
    public readonly getRealBuffer = (item: any): void =>{
        for (let prop in item){
            switch (prop){
                case 'actionBuffer':
                    item.actionBuffer = (item.actionBuffer - item.bufferG).toFixed(2);
                    break;
                case 'bufferG':
                    //item.bufferG = (item.bufferG - item.actionSafetyBuffer).toFixed(2);
                    break;
                case 'bufferY':
                    item.bufferY = (item.bufferY - item.actionSafetyBuffer).toFixed(2);
                    break;
                case 'bufferR':
                    item.bufferR = (item.bufferR - item.actionSafetyBuffer).toFixed(2);
                    break;
                case 'actionSafetyBuffer':
                    item.actionSafetyBuffer = (item.actionSafetyBuffer - item.safetyBuffer).toFixed(2);
                    break;
            }
        }
    }

    //# generate chart line properties for line chart
    public readonly genChartProps = async (translateService: TranslateService, commonService: CommonService, isAdmin: boolean = true): Promise<ChartLineModel[]> =>{
        let settings = await this.getChartColumns(commonService);
            settings = settings.filter(s => s.visibility === 1 || isAdmin && s.visibility === 2);
        let names = settings ? settings.map(item => this.lowerCaseFirstLetter(item.columnName)) : [];

        let chartLines = [
            // new ChartLineModel("actionBuffer", "#AAFFAA", true, true, true, true, "Акционный буфер"0),
            new ChartLineModel("actionBuffer", "#AAFFAA", true, true, true, true, "Акционный буфер", "MainChart_ActionBuffer", 20),
            new ChartLineModel("bufferG", "#7FC07F", true, false, true, true, "Буфер", "MainChart_BufferG", 10),
            new ChartLineModel("bufferY", "#FFFFBF", true, false, true, true, "Жёлтая зона", "MainChart_BufferY", 220),
            new ChartLineModel("bufferR", "#FF7F7F", true, false, true, true, "Красная зона", "MainChart_BufferR", 230),
            new ChartLineModel("actionSafetyBuffer", "#dd0000", true, true, false, true, "Безопасный акционный буфер", "MainChart_ActionSafetyBuffer", 40),
            new ChartLineModel("safetyBuffer", "#B22222", true, false, true, true, "Safety stock", "MainChart_SafetyBuffer", 30),
            new ChartLineModel("balance", "#87CEFA", false, true, false, true, "Остаток", "MainChart_Balance", 50),
            new ChartLineModel("valueIn", "#DAA520", false, true, false, true, "Приход", "MainChart_ValueIn", 80),
            new ChartLineModel("valueOut", "#336666", false, true, false, true, "Расход", "MainChart_ValueOut", 120),
            new ChartLineModel("shelfQuantity", "#0000FF", false, true, false, false, "Выкладка", "MainChart_ShelfQuantity", 150),
            new ChartLineModel("packageValue", "#8B008B", false, true, false, false, "Упаковка", "MainChart_PackageValue", 140),
            new ChartLineModel("replenishmentTime", "#3F8359", false, true, false, false, "Время пополнения", "MainChart_ReplenishmentTime", 190),
            new ChartLineModel("maxBuffer", "#1E90FF", false, true, false, false, "Макс. буфер", "MainChart_MaxBuffer",170),
            new ChartLineModel("qntOut1", "#FF4500", false, true, false, true, "Продажи", "MainChart_QntOut1",90),
            new ChartLineModel("qntOut2", "#FF1493", false, true, false, false, "Другие расходы", "MainChart_QntOut2",130),
            new ChartLineModel("discountQnt", "#7FFF00", false, true, false, false, "Продажи по уценке", "MainChart_DiscountQnt",100),
            new ChartLineModel("maxQuantity", "#9c0c2e", false, true, false, false, "Макс. выкладка", "MainChart_MaxShelfQuantity",180),
            new ChartLineModel("minBuffer", "#3b0fab", false, true, false, false, "Мин. буфер", "MainChart_MinBuffer",160),
            new ChartLineModel("checkedBalance", "#1a8263", false, true, false, false, "Остаток за период", "MainChart_CheckedBalance", 60),
            new ChartLineModel("targetStockLevel", "#9896a3", false, true, true, false, "Максимальное потребление за время пополнения", "MainChart_TargetStockLevel",200),
            new ChartLineModel("checkedSales", "#663300", false, true, false, false, "Продажи за период", "MainChart_SalesForPeriod", 110),
            new ChartLineModel("avgToReplenishment", "#DA4338", false, true, false, false, "Ср. продажа за время пополнения", "MainChart_AvgSaleForReplenishmentTime", 210),
            new ChartLineModel("transit", "#FADE4E", false, true, false, false, "Транзит", "MainChart_Transit", 70),
            new ChartLineModel("actionBalance", "#669999", false, true, false, false, "Акционный остаток", "MainChart_ActionBalance", 240),
            new ChartLineModel("actionTransit", "#FF9600", false, true, false, false, "Акционный транзит", "MainChart_ActionTransit", 250)
        ];

        this.remFromArrJoin(chartLines, 'name', names, true);
        chartLines = await this.translateData(chartLines, translateService, 'lineTranslateKey', 'lineNamePopup');

        return await this.translateData(chartLines, translateService, 'lineTranslateKey', 'lineName');

        //return await this.translate(chartLines, translateService);
    }

    //# generate chart line properties for bubble chart
    public readonly genBubbleChartProps = async (translateService: TranslateService, commonService: CommonService, isAdmin: boolean = true): Promise<ChartLineModel[]> =>{
        let settings = await this.getChartColumns(commonService);
            settings = settings.filter(s => s.visibility === 1 || isAdmin && s.visibility === 2);
        let names = settings ? settings.map(item => this.lowerCaseFirstLetter(item.columnName)) : [];

        let bubbleChartLines = [
            new ChartLineModel("action", "#ff0000", false, true, false, false, "Акция", "BubbleChart_Action", 10),
            new ChartLineModel("season", "#00ff00", false, true, false, false, "Сезон", "BubbleChart_Season",20),
            new ChartLineModel("vacation", "#0000ff", false, true, false, false, "Каникулы", "BubbleChart_Vacation",30),
            new ChartLineModel("holiday", "#da70d6", false, true, false, false, "Праздник", "BubbleChart_Holiday",40),
            new ChartLineModel("orderDay", "#68a8c3", false, true, false, false, "День заказа", "BubbleChart_OrderDay",50),
            new ChartLineModel("deliveryDay", "#008000", false, true, false, false, "День поставки", "BubbleChart_DeliveryDay",60),
            new ChartLineModel("bufferGrowFixed", "#b22222", false, true, false, false, "Фиксирование буфера на рост","BubbleChart_BufferGrowFixed", 70),
            new ChartLineModel("bufferDecreaseFixed", "#000080", false, true, false, false, "Фиксирование буфера на падение","BubbleChart_BufferDecreaseFixed", 80),
            new ChartLineModel("firstPriceItem", "#e5c104", false, true, false, false, "Товар первой цены", "BubbleChart_FirstPriceItem",90)
        ];

        this.remFromArrJoin(bubbleChartLines, 'name', names, true);

        return await this.translateData(bubbleChartLines, translateService, 'lineTranslateKey', 'lineName');

        // return await this.translate(bubbleChartLines, translateService);
    }

    //# translate line names for legeng and charts
    private translate = async (chartLines: ChartLineModel[], translateService: TranslateService): Promise<ChartLineModel[]> =>{
        let keys = this.genKeysForTranslate(chartLines),
            translates = await translateService.get(keys.map(item => item.key)).toPromise();
        this.setTranslates(keys, chartLines, translates);

        return chartLines;
    }

    //# generate keys for translate
    public readonly genKeysForTranslate = (data: ChartLineModel[]): { key: string, name: string, translate: string }[] =>{
        return data.map(item =>{
            return {key: item.lineTranslateKey, name: item.name, translate: ''};
        });
    };

    //# set translate for chart obj
    private setTranslates = (keys: { key: string, name: string, translate: string }[], data: ChartLineModel[], t: any): void =>{
        keys.forEach(item =>{
            data.forEach(inItem =>{
                if (item.name === inItem.name){
                    inItem.lineName = t[item.key];
                    inItem.lineNamePopup = t[item.key]
                }
            })
        })
    };

    //# compare two dates, if they equals return true
    public compareDates = (date1: string | Moment, date2: string | Moment): boolean => {
        return moment.utc(date1).isSame(date2, 'day')
    }

    public readonly getChartColumns = async (service: CommonService): Promise<ColumnSettingsBase[]> => {
        let columnsSettings = null;
        try {
            let response = await service.getTableSettings( 'Stocks', 'ChartData', 0).toPromise();
                        columnsSettings = response.columns
        } catch (e){

        }
        return columnsSettings;
    }

    /*public readonly getTabsList = (GUID: string, allTabsData: CodeNameChartTabs[]): CodeNameChartTabs => {
        return allTabsData ? allTabsData.filter(item => item.GUID === GUID).find(item => !!item) : null;
    }*/
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-helper.ts